<template>
	<div class="card bg-primary border-0">
		<div class="card-body">
			<div class="d-flex">
				<div>
					<div class="icon text-white">
						<i class="bi bi-cake2"></i>
					</div>
				</div>
				<div class="ps-4 vstack gap-1">
					<router-link :to="{ name: 'customer.index', query: { birthdate: 0 } }" class="h4 text-white lh-xs stretched-link">{{ (customers.length == 1) ? `1 cliente cumple años hoy` : `${customers.length} clientes cumplen años hoy` }}</router-link>
					<span class="text-sm text-white opacity-8 lh-sm">{{ names }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { computed } from 'vue';
	import _ from 'lodash';

	export default {
		props: {
			customers: Array
		},
		setup(props) {
			const names = computed(() => {
				let max = 5,
					data = _.map(_.take(props.customers, max), 'name');

				if(data.length == 1) return data[0];
				else if(props.customers.length > max) return `${_.join(data, ', ')} y más`;
				else if(props.customers.length <= max) return `${_.join(_.initial(data), ', ')} y ${_.last(data)}`;
				else return ``;
			});

			return { names };
		}
	}
</script>